<template>
  <div class="registration-template" theme>
    <div id="theme-registration" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'registration',
      parts: [
        {
          elem: '#theme-registration',
          htmlFile: 'registration'
        }
      ]
    }
  },
  mounted() {
    if (this.loggedInUser) {
      this.openLink('/')
    }
  }
}
</script>
